export const hash = 'bd5ebb91-81df-4f82-8a69-c5314f4bd214';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v2.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket-v2.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://microbiologia-2022.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'XIV Simpósio Brasileiro de Microbiologia Aplicada';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpeg';
export const authTitle = 'XIV Simpósio Brasileiro de Microbiologia Aplicada';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};


export const defaultTheme = {
  defaultBackground: 'rgb(0,50,150)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: '#fff',
    backgroundSticky: '#fff',
    backgroundMobile: 'rgb(0,50,150)',
    color: 'rgb(0, 14, 64)',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${hash}:token`);
  return token;
};
